export const ru = {
    'mutation-warning':
        'Операция занимает больше времени, чем обычно. Перезагрузите страницу позже, чтобы увидеть изменения.',
    'request-error': 'Обновите страницу либо попробуйте зайти позже'
};
